import Relay from 'react-relay';
import ObjectDetail from './ObjectDetail';
import ObjectDetailDefinition from './Definition';
import Location from './Location';
import ObjectSlider from '../Slider';
import ObjectRelObjects from '../RelObjects';
import ObjectRelDesigners from '../RelPersons/Designers';
import ObjectRelProducers from '../RelPersons/Producers';
import settings from '../../../../config/settings';
import {getCurrentLanguage} from '../../../localData';

const lang = getCurrentLanguage() || settings.defaultLanguage;

export default Relay.createContainer(ObjectDetail, {
    initialVariables: {
        id: 144800,
        showFixedHeader: false,
        lang: getCurrentLanguage() || settings.defaultLanguage,
    },
    fragments: {
        store: () => Relay.QL`
            fragment on Store {
                myCollectionIds,
                ${ObjectSlider.getFragment('store')},
                object(id: $id, lang: $lang) {
                    id,
                    ObjObjectNumberTxt,
                    ObjObjectTitleTxt,
                    ObjObjectTitleSubTxt,
                    ObjStandardImage,
                    ObjFloorplan,
                    ObjThumbnail,
                    ObjDesigner,
                    ObjCategoryVoc,
                    ObjDateGrp_DateFromTxt,
                    ObjDateGrp_NotesClb,
                    ObjDateGrp_Notes3Clb,
                    ObjDateTxt,
                    ObjMaterialTechniqueTxt,
                    ObjDimension,
                    ObjObjectNumberGrp_Part1Txt,
                    ObjMarkdown,
                    ObjMarkdownKids,
                    ObjObjectsCount,
                    ObjMultimediaCount,
                    ObjMultimediaWidths,
                    ObjPersonsCount,
                    ObjHighlight,
                    ${Location.getFragment('object')},
                    ${ObjectDetailDefinition.getFragment('object')},
                    ${ObjectSlider.getFragment('object')},
                    ${ObjectRelObjects.getFragment('object')},
                    ${ObjectRelDesigners.getFragment('object')},
                    ${ObjectRelProducers.getFragment('object')},
                }
            }
        `,
    },
});



// WEBPACK FOOTER //
// ./app/components/Object/Detail/index.js